import { connect } from 'react-redux';

import UsageMainPane from '../../components/usage/UsageMainPane';
import {
  getProjectZoneId,
  getUsageChartOptions,
  getUsageEvents,
  getUsageExecuteTime,
  isUsageExecuting,
} from '../../reducers/analyticsApp';

const mapStateToProps = (state) => ({
  executing: isUsageExecuting(state) && !getUsageEvents(state),
  options: getUsageChartOptions(state),
  result: getUsageEvents(state),
  executeTime: getUsageExecuteTime(state),
  timezone: getProjectZoneId(state),
});

export default connect(mapStateToProps)(UsageMainPane);
